import React from 'react';
import classNames from 'classnames';
import { getResultPointsByCourt } from 'twain-sport-fe-mono/utils/getResultPointsByCourt';
import { IRngResultItem, IRngResultByCourt } from 'twain-sport-fe-mono/interfaces/';
import { RngResultItem } from './RngResultItem';
import classes from './RngResults.module.scss';

interface IProps {
    results: IRngResultItem[] | IRngResultByCourt;
    className?: string;
    itemClassName?: string;
    colonClassName?: string;
}

export const RngResults: React.FC<React.PropsWithChildren<IProps>> = (props) => {
    const isResultList = Array.isArray(props.results);

    return (
        <div className={classNames(classes.container, props.className)}>
            <RngResultItem className={props.itemClassName}>
                {isResultList
                    ? getResultPointsByCourt(props.results as IRngResultItem[], 'left')
                    : (props.results as IRngResultByCourt).left}
            </RngResultItem>
            <span className={classNames(classes.colon, props.colonClassName)}>:</span>
            <RngResultItem className={props.itemClassName}>
                {isResultList
                    ? getResultPointsByCourt(props.results as IRngResultItem[], 'right')
                    : (props.results as IRngResultByCourt).right}
            </RngResultItem>
        </div>
    );
};
